













import { defineComponent, PropType } from '@vue/composition-api'
import { Location } from '@/composables/collection/use-collection-taiwan'
import { tdCarModelLocation } from '@/modules/ga4'

export default defineComponent({
  props: {
    query: {
      type: Object,
      default: {},
    },
    title: {
      type: String,
      default: '',
    },
    locations: {
      type: Array as PropType<Location[]>,
      default: () => [],
    },
  },
  setup () {
    return {
      tdCarModelLocation,
    }
  },
})
